import { defineMessage } from 'services/localization';

export const messages = {
    salesDetailsSection: defineMessage('sales_details'),
    shippingDetailsSection: defineMessage('shipping_details_1'),
    revenueDetailsSection: defineMessage('revenue_details'),
    paymentDetailsSection: defineMessage('payment_details_1'),
    salesRep: defineMessage('sales_rep_1'),
    opportunity: defineMessage('opportunity'),
    salesEffectiveDate: defineMessage('sales_effective_date'),
    excludeCommissions: defineMessage('exclude_commissions'),
    partner: defineMessage('partner'),
    shipDate: defineMessage('ship_date'),
    shipMethod: defineMessage('ship_method'),
    shipComplete: defineMessage('ship_complete'),
    shippingAddress: defineMessage('shipping_address_1'),
    paymentMethod: defineMessage('payment_method'),
    creditCardNumber: defineMessage('credit_card'),
    creditCardExpirationDate: defineMessage('expires_mmyyyy'),
    creditCardCardholderName: defineMessage('name_on_card'),
    creditCardStreet: defineMessage('card_street'),
    creditCardZipCode: defineMessage('card_zip_code'),
    creditCardProcessor: defineMessage('payment_processing_profile'),
    creditCardApproved: defineMessage('credit_card_approved'),
    pnRef: defineMessage('pn_ref'),
    authCode: defineMessage('auth_code'),
    avsStreetMatch: defineMessage('avs_street_match'),
    avsZipMatch: defineMessage('avs_zip_match'),
    revenueStatus: defineMessage('revenue_status'),
    recognizedRevenue: defineMessage('recognized_revenue'),
    deferredRevenue: defineMessage('deferred_revenue'),
    positiveBooleanValue: defineMessage('yes'),
    revenueStatusPending: defineMessage('pending'),
    revenueStatusInProgress: defineMessage('in_progress_1'),
    revenueStatusCompleted: defineMessage('completed'),
    revenueStatusRevCommitment: defineMessage('on_revenue_commitment'),
};
